import script from "./UPWebsiteLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPWebsiteLink.vue?vue&type=script&setup=true&lang=ts"

import "./UPWebsiteLink.vue?vue&type=style&index=0&id=677624c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677624c0"]])

export default __exports__